// Fixed status washes shared by the schedule grid's aggregate row, the setup boss-rules footer,
// and the Vault cell's top/bottom tiers: green = raid-ready (>= threshold), red = under-strength.
// Status colors are intentionally theme-fixed (each hue mixed with --background for light/dark)
// so "ready" and "under" read the same in every table.
export const STATUS_GREEN =
  "bg-[color-mix(in_oklab,oklch(0.62_0.15_150)_16%,var(--background))] text-[oklch(0.55_0.14_150)]";
export const STATUS_RED =
  "bg-[color-mix(in_oklab,oklch(0.6_0.16_25)_16%,var(--background))] text-[oklch(0.6_0.16_25)]";
